// extracted by mini-css-extract-plugin
export default {"bgVid":"Header_bgVid__Xp-Wn","rowHeader":"Header_rowHeader__-POEt"};